import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { AllResultsResponse, ExportStatusValue, ResultData } from 'types/result';
import type { Ordering } from 'screens/home/utils';
import { pageFromNextLink } from 'utils/pagination';

export function useGetResults(
  params?: {
    ordering?: Ordering | string;
    start_date?: string;
    end_date?: string;
    search?: string;
    export_status?: ExportStatusValue | undefined;
    medatixxPatientId?: string;
    page_size?: number;
  },
  options?: { enabled?: boolean; refetchInterval?: number }
) {
  return useInfiniteQuery({
    queryKey: ['results', params],
    queryFn: ({ pageParam }) => {
      const fetchParams: Record<string, unknown> = { ...params };
      const page = pageFromNextLink(pageParam);
      if (page) fetchParams.page = page;
      return get('getResults', undefined, fetchParams) as Promise<AllResultsResponse>;
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.next || null,
    enabled: options?.enabled ?? true,
    refetchInterval: options?.refetchInterval,
  });
}

export function useGetOneResult(id: number, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['conversation', id],
    queryFn: () => get('getOneResult', id) as Promise<ResultData>,
    enabled: options?.enabled ?? true,
  });
}
